<template>
  <div>
    <div class="module-title-container">
      <span>{{ title }}</span>
      <slot></slot>
    </div>

    <Divider v-if="divider" class="m-b50"></Divider>
  </div>
</template>

<script>
import Divider from './divider.vue'

export default {
  props: {
    title: String,
    divider: { type: Boolean, default: () => false }
  },
  components: {
    Divider
  }
}
</script>

<style lang="stylus" scoped>
.module-title-container
  margin 25px 0 25px 0
  color #333
  height 16px
  padding-left 30px
  padding-right 20px
  line-height 16px
  font-size 16px
  position relative
  font-weight bold
  display flex
  &:before
    content ''
    position absolute
    top 3px
    left 0
    background #cd974c
    width 4px
    height 12px

.fx
  display none
</style>
